// extracted by mini-css-extract-plugin
module.exports = {"body":"Language_body__2gy5H"};